


/**
 * Returns random string.
 */
export const createId = () => {
    return Math.random().toString(36).slice(2);
};